
export const MenuItems = [

            {
                title: 'Analytics',
                icon: require("../../Assets/presention-chart.png"),
                path: '/Analytics',
            },
            {
                title: 'Sales',
                icon: require("../../Assets/presention-chart.png"),
                path: '/Sales',
            },
            {
                title: 'Inventory',
                icon: require("../../Assets/presention-chart.png"),
                path: '/SInventory',
            },
            {
                title: 'Scheme',
                icon: require("../../Assets/presention-chart.png"),
                path: '/Scheme',
            },
            
            // Clinical Team

            {
                title: 'Dashboard',
                icon: require("../../Assets/presention-chart.png"),
                path: '/CDahboard',
            },

            // Marketing Analytics 
            {
                title: 'M Analytics',
                icon: require("../../Assets/presention-chart.png"),
                path: '/MAnalytics',
            },
            {
                title: `KPI’s`,
                icon: require("../../Assets/presention-chart.png"),
                path: '/KPIS',
            },
            {
                title: "Events",
                icon: require('../../Assets/folder-open.png'),
                path: '/E',
            },


            // Finance Head 
           /* {
                title: 'F Analytics',
                icon: require("../../Assets/presention-chart.png"),
                path: '/FAnalytics',
            },*/

            {
                title: 'Analytics',
                icon: require("../../Assets/presention-chart.png"),
                path: '/FSales',
            },
            
            {
                title: 'F Inventory',
                icon: require("../../Assets/presention-chart.png"),
                path: '/FInventory',
            },

            {
                title: 'PurchaseOrder',
                icon: require("../../Assets/presention-chart.png"),
                path: '/FPurchaseOrder',
            },


            
]